import { Inject, Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableService } from 'src/app/_metronic/shared/crud-table';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { finalize, tap, map } from 'rxjs/operators';
import { RequestTypes } from 'src/app/_metronic/shared/crud-table/models/request-types.enum';
import { Observable } from 'rxjs';
import { CollectionModel } from '../models/collection.model';

@Injectable({
    providedIn: 'root',
})

export class CollectionService
    extends TableService<CollectionModel>
    implements OnDestroy {
    BASE_URL = environment.apiUrl;
    GET_ALL_URL = 'Collection';
    CREATE_URL = 'Collection';
    GET_ONE_URL = 'Collection';
    UPDATE_URL = 'Collection';
    DELETE_URL = 'Collection';

    constructor(
        @Inject(HttpClient) http,
        router: Router,
        activatedRoute: ActivatedRoute
    ) {
        super(http, router, activatedRoute);
    }

    getData(catId: number) {
        this.fetchItemsOnly({ queryParams: { categoryId: catId } });
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sb) => sb.unsubscribe());
    }
    updateOrdering(mainList: CollectionModel[]): Observable<any> {
        return this.http.post(
            `${this.BASE_URL}/${this.CREATE_URL}`,
            mainList
        );
    }
}
